import {
  API_METHODS
} from "../../constant";
export const agreementsApi = (
  _getAll,
  _get,
  _update,
  _create,
  _delete,
  paramsIn
) => {
  return {
    [API_METHODS.GET_AGREEMENTS]: () => {
      let urlReq = `/Agreements/${paramsIn.id}`;
      return _get(urlReq);
    },
    [API_METHODS.GET_ALL_AGREEMENTS]: () => {
      let urlReq = "/Agreements";
      return _getAll(urlReq);
    },
    [API_METHODS.UPDATE_AGREEMENTS]: () => {
      let urlReq = "/Agreements";
      return _update(urlReq);
    },
    [API_METHODS.CREATE_AGREEMENTS]: () => {
      let urlReq = "/Agreements";
      return _create(urlReq);
    },
    [API_METHODS.DELETE_AGREEMENTS]: () => {
      let urlReq = `/Agreements/${paramsIn.id}`;
      return _delete(urlReq);
    },

    [API_METHODS.GET_AGREEMENTS_FOR_CRM_CORP] : ()=> {
      let urlReq = '/Agreements/Corp'
      return _getAll(urlReq);
    },
    [API_METHODS.GET_ALL_AGREEMENTS_COMMON] : ()=> {
      let urlReq = '/Agreements'
      return _getAll(urlReq, paramsIn.dopParams?paramsIn.dopParams:{});
    }
  };
};
